"use client";

import {
  AuthContainer,
  AuthCard,
  Title,
  Subtitle,
  Form,
  InputGroup,
  Label,
  Input,
  Button,
  Footer,
  Wrapper,
} from "./styled";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { forgotPasswordThunk } from "../../store/actions/auth.action";
import { message } from "antd";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormHelperText } from "@mui/material";

type FormValues = {
  email: string;
  password: string;
};

const schema = yup.object({
  email: yup
    .string()
    .required("Email Address is required.")
    .email("Email Address is invalid"),
  password: yup.string().required("Password is required."),
  confirmPassword: yup
    .string()
    .required("Confirm Password is required!")
    .oneOf([yup.ref("password")], "The confirmation password does not match the original."),
});

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const form = useForm({
    defaultValues: {
      email: "",
      password: "",
      confirmPassword: "",
    },
    resolver: yupResolver(schema),
  });
  const { register, handleSubmit, formState, watch, setValue } = form;
  const { errors } = formState;

  const onSubmit = async (data: FormValues) => {
    try {
      await dispatch(
        forgotPasswordThunk({
          email: data.email,
          password: data.password,
        })
      ).unwrap();
      navigate("/verify-code", {
        state: { username: data.email, verifyType: 2 },
      });
    } catch (e: any) {
      message.error(e?.message || "Something went wrong!");
    }
  };

  return (
    <AuthContainer>
      <Wrapper>
        <AuthCard>
          {/* <Logo>
            <img src="/placeholder.svg?height=32&width=32" alt="Logo" />
            <span>Kardo AI</span>
          </Logo> */}

          <Title>Reset Password</Title>
          <Subtitle>
            Enter your email and new password. We'll send you a code to reset
            your password.
          </Subtitle>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <InputGroup>
              <Label htmlFor="email">Email address</Label>
              <Input
                id="email"
                type="email"
                placeholder="name@example.com"
                {...register("email")}
              />
              <FormHelperText
                style={{ fontFamily: "Outfit", margin: "0", color: "red" }}
              >
                {errors.email?.message}
              </FormHelperText>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter your new password"
                {...register("password")}
              />
              <FormHelperText
                style={{ fontFamily: "Outfit", margin: "0", color: "red" }}
              >
                {errors.password?.message}
              </FormHelperText>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="password">Confirm Password</Label>
              <Input
                id="confirm-password"
                type="password"
                placeholder="Confirm your password"
                {...register("confirmPassword")}
              />
              <FormHelperText
                style={{ fontFamily: "Outfit", margin: "0", color: "red" }}
              >
                {errors.confirmPassword?.message}
              </FormHelperText>
            </InputGroup>
            <Button type="submit">Reset Password</Button>
          </Form>

          <Footer>
            You already have an existing account? <Link to="/login">Login</Link>
          </Footer>
        </AuthCard>
      </Wrapper>
    </AuthContainer>
  );
}
